module.exports = __webpack_public_path__ + "img/Sichuan-speed.3b6852f2.png";